import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import { defineComponent, reactive, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useState } from "@/hooks/mapGet/index.js";
import { useStore } from "vuex";
import ListDetailTop from "@/components/list-detail/listDetailTop.vue";
import ListDetail from "@/components/list-detail/listDetail.vue";
import Comment from "@/components/list-detail/Comment/Comment.vue";
import Loading from "@/baseui/loading/loading.vue";
import ListDetailNav from "@/components/list-detail/listDetailNav.vue";
import AlbumDesc from "./cpns/albumDesc.vue";
export default defineComponent({
  name: "AlbumDetail",
  setup: function setup() {
    var route = useRoute();
    var state = useState("Detail", ["albumDetail"]);
    var store = useStore();
    var isShow = ref(0);
    /* 歌单评论请求数据 */

    var alumCmtResData = reactive({
      id: route.params.id,
      limit: 30,
      offset: 0
    });
    /* 因配合push过来的跳转,此处用watchEffect处理 */
    // store.dispatch("Detail/getAlbumDetail", route.params.id);
    // store.dispatch("Detail/getAlbumCmt", alumCmtResData);

    /* 导航列表 */

    var navList = reactive(["歌曲列表", "评论", "专辑详情"]);
    /* 导航点击事件 */

    var titleClick = function titleClick(index) {
      isShow.value = index;
    };
    /* 评论页数改变事件 */


    var changeCurrent = function changeCurrent(page) {
      state.commentList.value.comments.length = 0;
      alumCmtResData.offset = (page - 1) * alumCmtResData.limit;
      store.dispatch("Detail/getAlbumCmt", alumCmtResData);
    };
    /* 当路由id变化则重新请求数据 */


    watch(function () {
      return route.params.id;
    }, function () {
      if (route.path.indexOf("/main/albumdetail") !== -1) {
        store.dispatch("Detail/getAlbumDetail", route.params.id);
        store.dispatch("Detail/getAlbumCmt", alumCmtResData);
      }
    }, {
      immediate: true
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      isShow: isShow,
      navList: navList,
      route: route,
      alumCmtResData: alumCmtResData,
      titleClick: titleClick,
      changeCurrent: changeCurrent
    });
  },
  components: {
    ListDetailTop: ListDetailTop,
    ListDetail: ListDetail,
    ListDetailNav: ListDetailNav,
    Comment: Comment,
    Loading: Loading,
    AlbumDesc: AlbumDesc
  }
});